import { Card } from "@/components/ui/card"
import { InstagramHeader } from "@/components/instagram/InstagramHeader"
import { PostForm } from "@/components/instagram/PostForm"
import { PostsList } from "@/components/instagram/PostsList"

export default function InstagramPage() {
  return (
    <div className="container mx-auto p-4 space-y-8">
      <InstagramHeader />
      
      <Card className="p-6 space-y-6">
        <PostForm />
      </Card>

      <PostsList />
    </div>
  )
}